import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { Button } from 'native-base';

import { toaster } from 'components/toaster/toaster';

import { useCartContext } from '../hooks/use-cart-context';

export const DebugToggleButton: React.FC = () => {
  const { isDiagnosticsEnabled, debug, setCartState } = useCartContext();

  if (!isDiagnosticsEnabled) {
    return null;
  }

  const handleToggle = () => {
    const newDebugState = !debug;
    setCartState(prev => ({
      ...prev,
      debug: newDebugState && isDiagnosticsEnabled,
    }));
    // Show toast notification
    toaster.hideAll();
    toaster.informative(
      newDebugState ? 'Cart Debug mode enabled ✅' : 'Cart Debug mode disabled ❌'
    );
  };

  return (
    <Button
      onPress={handleToggle}
      variant="ghost"
      size="sm"
      accessibilityLabel={debug ? 'Disable debug mode' : 'Enable debug mode'}
      testID="debug-toggle-button"
    >
      <Icon size={5} name={'mi:settings'} color="white" />
      <Icon
        color="white"
        size={3}
        name={debug ? 'mi:visibility' : 'mi:visibility-off'}
        style={{ position: 'absolute', right: -10, top: 13 }}
      />
    </Button>
  );
};
